// extracted by mini-css-extract-plugin
export default {"root":"prompt-section_root__B1fcy"};